import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const BlogPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#1A3A5F] to-[#4D8BC9] text-white">
        <div className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Blog e Notícias</h1>
            <p className="text-xl mb-8">
              Fique por dentro das últimas novidades, tendências e informações técnicas do setor industrial
            </p>
          </motion.div>
        </div>
      </section>

      {/* Artigos em Destaque */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Artigos em Destaque</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Confira nossos artigos mais recentes sobre tendências, tecnologias e boas práticas no setor industrial
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Artigo 1 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#1A3A5F] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <span className="text-sm text-gray-500">10 de Julho, 2025</span>
                  <span className="mx-2 text-gray-300">|</span>
                  <span className="text-sm text-[#4D8BC9]">Inspeção</span>
                </div>
                <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">Novas Tecnologias de Inspeção para Vasos de Pressão</h3>
                <p className="text-gray-700 mb-4">
                  Conheça as mais recentes tecnologias de inspeção não destrutiva para vasos de pressão e como elas 
                  estão revolucionando a indústria, aumentando a segurança e reduzindo custos de manutenção.
                </p>
                <Link 
                  to="/blog/novas-tecnologias-inspecao" 
                  className="inline-block text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
                >
                  Leia mais →
                </Link>
              </div>
            </motion.div>

            {/* Artigo 2 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#4D8BC9] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <span className="text-sm text-gray-500">5 de Julho, 2025</span>
                  <span className="mx-2 text-gray-300">|</span>
                  <span className="text-sm text-[#4D8BC9]">Normativas</span>
                </div>
                <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Atualizações na NR-13: O Que Mudou e Como se Adequar</h3>
                <p className="text-gray-700 mb-4">
                  Análise detalhada das recentes atualizações na NR-13, que regulamenta caldeiras, vasos de pressão e 
                  tubulações, e orientações práticas para adequação às novas exigências.
                </p>
                <Link 
                  to="/blog/atualizacoes-nr13" 
                  className="inline-block text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
                >
                  Leia mais →
                </Link>
              </div>
            </motion.div>

            {/* Artigo 3 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="h-48 bg-[#1A3A5F] flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <span className="text-sm text-gray-500">28 de Junho, 2025</span>
                  <span className="mx-2 text-gray-300">|</span>
                  <span className="text-sm text-[#4D8BC9]">Eficiência Energética</span>
                </div>
                <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">Eficiência Energética em Caldeiras Industriais</h3>
                <p className="text-gray-700 mb-4">
                  Estratégias e tecnologias para aumentar a eficiência energética em caldeiras industriais, 
                  reduzindo custos operacionais e minimizando o impacto ambiental.
                </p>
                <Link 
                  to="/blog/eficiencia-energetica-caldeiras" 
                  className="inline-block text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
                >
                  Leia mais →
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Categorias */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Categorias</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Explore nossos artigos por categorias e encontre informações específicas para sua área de interesse
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {/* Categoria 1 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#1A3A5F]">Inspeção e Ensaios</h3>
              <p className="text-gray-700 mb-4">
                Artigos sobre técnicas de inspeção, ensaios não destrutivos e análise de integridade.
              </p>
              <Link 
                to="/blog/categoria/inspecao" 
                className="inline-block text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
              >
                Ver artigos →
              </Link>
            </motion.div>

            {/* Categoria 2 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#4D8BC9]">Normativas e Regulamentos</h3>
              <p className="text-gray-700 mb-4">
                Atualizações e análises sobre normas técnicas, regulamentos e legislação do setor.
              </p>
              <Link 
                to="/blog/categoria/normativas" 
                className="inline-block text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
              >
                Ver artigos →
              </Link>
            </motion.div>

            {/* Categoria 3 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#1A3A5F]">Eficiência Energética</h3>
              <p className="text-gray-700 mb-4">
                Estratégias e tecnologias para otimização energética em processos industriais.
              </p>
              <Link 
                to="/blog/categoria/eficiencia" 
                className="inline-block text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
              >
                Ver artigos →
              </Link>
            </motion.div>

            {/* Categoria 4 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#4D8BC9]">Segurança Industrial</h3>
              <p className="text-gray-700 mb-4">
                Boas práticas, procedimentos e tecnologias para garantir a segurança em ambientes industriais.
              </p>
              <Link 
                to="/blog/categoria/seguranca" 
                className="inline-block text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
              >
                Ver artigos →
              </Link>
            </motion.div>

            {/* Categoria 5 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#1A3A5F]">Manutenção Preditiva</h3>
              <p className="text-gray-700 mb-4">
                Técnicas e tecnologias para manutenção preditiva e monitoramento de condições de equipamentos.
              </p>
              <Link 
                to="/blog/categoria/manutencao" 
                className="inline-block text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
              >
                Ver artigos →
              </Link>
            </motion.div>

            {/* Categoria 6 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#4D8BC9]">Sustentabilidade</h3>
              <p className="text-gray-700 mb-4">
                Práticas e tecnologias para redução de impacto ambiental e operações industriais sustentáveis.
              </p>
              <Link 
                to="/blog/categoria/sustentabilidade" 
                className="inline-block text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
              >
                Ver artigos →
              </Link>
            </motion.div>

            {/* Categoria 7 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: 0.6 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#1A3A5F]">Tecnologia e Inovação</h3>
              <p className="text-gray-700 mb-4">
                Novidades tecnológicas, tendências e inovações para o setor industrial.
              </p>
              <Link 
                to="/blog/categoria/tecnologia" 
                className="inline-block text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
              >
                Ver artigos →
              </Link>
            </motion.div>

            {/* Categoria 8 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: 0.7 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md text-center"
            >
              <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-2 text-[#4D8BC9]">Gestão e Liderança</h3>
              <p className="text-gray-700 mb-4">
                Estratégias de gestão, liderança e desenvolvimento de equipes no setor industrial.
              </p>
              <Link 
                to="/blog/categoria/gestao" 
                className="inline-block text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
              >
                Ver artigos →
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Artigos Recentes */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Artigos Recentes</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Fique por dentro das últimas publicações do nosso blog
            </p>
          </motion.div>

          <div className="space-y-8">
            {/* Artigo 1 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="grid grid-cols-1 md:grid-cols-4">
                <div className="md:col-span-1 bg-[#1A3A5F] h-full min-h-[200px] md:min-h-0 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div className="md:col-span-3 p-6">
                  <div className="flex items-center mb-4">
                    <span className="text-sm text-gray-500">15 de Junho, 2025</span>
                    <span className="mx-2 text-gray-300">|</span>
                    <span className="text-sm text-[#4D8BC9]">Inspeção</span>
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">Inspeção Remota: O Futuro da Manutenção Industrial</h3>
                  <p className="text-gray-700 mb-4">
                    A inspeção remota está revolucionando a manutenção industrial, permitindo o monitoramento 
                    contínuo de equipamentos críticos sem a necessidade de paradas programadas. Neste artigo, 
                    discutimos as tecnologias envolvidas, benefícios e desafios da implementação.
                  </p>
                  <Link 
                    to="/blog/inspecao-remota" 
                    className="inline-block text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
                  >
                    Leia mais →
                  </Link>
                </div>
              </div>
            </motion.div>

            {/* Artigo 2 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="grid grid-cols-1 md:grid-cols-4">
                <div className="md:col-span-1 bg-[#4D8BC9] h-full min-h-[200px] md:min-h-0 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="md:col-span-3 p-6">
                  <div className="flex items-center mb-4">
                    <span className="text-sm text-gray-500">10 de Junho, 2025</span>
                    <span className="mx-2 text-gray-300">|</span>
                    <span className="text-sm text-[#4D8BC9]">Sustentabilidade</span>
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Descarbonização na Indústria: Estratégias e Tecnologias</h3>
                  <p className="text-gray-700 mb-4">
                    A descarbonização é um dos principais desafios da indústria moderna. Neste artigo, 
                    apresentamos estratégias e tecnologias que estão sendo implementadas para reduzir 
                    as emissões de carbono e promover operações mais sustentáveis.
                  </p>
                  <Link 
                    to="/blog/descarbonizacao-industria" 
                    className="inline-block text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
                  >
                    Leia mais →
                  </Link>
                </div>
              </div>
            </motion.div>

            {/* Artigo 3 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="grid grid-cols-1 md:grid-cols-4">
                <div className="md:col-span-1 bg-[#1A3A5F] h-full min-h-[200px] md:min-h-0 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                  </svg>
                </div>
                <div className="md:col-span-3 p-6">
                  <div className="flex items-center mb-4">
                    <span className="text-sm text-gray-500">5 de Junho, 2025</span>
                    <span className="mx-2 text-gray-300">|</span>
                    <span className="text-sm text-[#4D8BC9]">Normativas</span>
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-[#1A3A5F]">Impacto da Nova Legislação Ambiental na Indústria</h3>
                  <p className="text-gray-700 mb-4">
                    A recente atualização da legislação ambiental traz novos desafios e oportunidades para 
                    o setor industrial. Neste artigo, analisamos as principais mudanças e como as empresas 
                    podem se adaptar para garantir a conformidade legal.
                  </p>
                  <Link 
                    to="/blog/legislacao-ambiental" 
                    className="inline-block text-[#1A3A5F] hover:text-[#4D8BC9] font-bold transition-colors"
                  >
                    Leia mais →
                  </Link>
                </div>
              </div>
            </motion.div>

            {/* Artigo 4 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div className="grid grid-cols-1 md:grid-cols-4">
                <div className="md:col-span-1 bg-[#4D8BC9] h-full min-h-[200px] md:min-h-0 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-white opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                  </svg>
                </div>
                <div className="md:col-span-3 p-6">
                  <div className="flex items-center mb-4">
                    <span className="text-sm text-gray-500">1 de Junho, 2025</span>
                    <span className="mx-2 text-gray-300">|</span>
                    <span className="text-sm text-[#4D8BC9]">Tecnologia</span>
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-[#4D8BC9]">Inteligência Artificial na Manutenção Preditiva</h3>
                  <p className="text-gray-700 mb-4">
                    A inteligência artificial está transformando a manutenção preditiva, permitindo a 
                    detecção precoce de falhas e a otimização dos planos de manutenção. Neste artigo, 
                    exploramos casos de uso e benefícios da implementação de IA na indústria.
                  </p>
                  <Link 
                    to="/blog/ia-manutencao-preditiva" 
                    className="inline-block text-[#4D8BC9] hover:text-[#1A3A5F] font-bold transition-colors"
                  >
                    Leia mais →
                  </Link>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="mt-12 text-center">
            <Link 
              to="/blog/todos" 
              className="inline-block bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold px-8 py-3 rounded-md transition-colors"
            >
              Ver Todos os Artigos
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-8"
            >
              <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Inscreva-se em Nossa Newsletter</h2>
              <p className="text-lg text-gray-700">
                Receba as últimas novidades, artigos e atualizações diretamente em seu e-mail
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-lg shadow-md"
            >
              <form className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Nome</label>
                    <input 
                      type="text" 
                      id="name" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]" 
                      placeholder="Seu nome"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2">E-mail</label>
                    <input 
                      type="email" 
                      id="email" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]" 
                      placeholder="seu.email@exemplo.com"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="interests" className="block text-gray-700 font-medium mb-2">Áreas de Interesse</label>
                  <select 
                    id="interests" 
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]"
                  >
                    <option value="">Selecione uma área de interesse</option>
                    <option value="inspecao">Inspeção e Ensaios</option>
                    <option value="normativas">Normativas e Regulamentos</option>
                    <option value="eficiencia">Eficiência Energética</option>
                    <option value="seguranca">Segurança Industrial</option>
                    <option value="manutencao">Manutenção Preditiva</option>
                    <option value="sustentabilidade">Sustentabilidade</option>
                    <option value="tecnologia">Tecnologia e Inovação</option>
                    <option value="gestao">Gestão e Liderança</option>
                  </select>
                </div>
                <div className="flex items-start">
                  <input 
                    type="checkbox" 
                    id="privacy" 
                    className="mt-1 mr-2"
                  />
                  <label htmlFor="privacy" className="text-gray-700">
                    Concordo em receber e-mails informativos do Grupo M7 CORP e estou ciente da 
                    <Link to="/privacidade" className="text-[#4D8BC9] hover:text-[#1A3A5F] ml-1">Política de Privacidade</Link>.
                  </label>
                </div>
                <div className="text-center">
                  <button 
                    type="submit" 
                    className="bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold px-8 py-3 rounded-md transition-colors"
                  >
                    Inscrever-se
                  </button>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1A3A5F] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Tem Alguma Dúvida ou Sugestão?</h2>
            <p className="text-xl mb-8">
              Entre em contato conosco para sugerir temas para nossos próximos artigos ou para 
              esclarecer dúvidas sobre os conteúdos publicados.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link 
                to="/contato" 
                className="bg-white text-[#1A3A5F] hover:bg-gray-100 font-bold px-8 py-3 rounded-md transition-colors"
              >
                Fale Conosco
              </Link>
              <Link 
                to="/faq" 
                className="bg-transparent border-2 border-white hover:bg-white hover:text-[#1A3A5F] text-white font-bold px-8 py-3 rounded-md transition-colors"
              >
                Perguntas Frequentes
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
